import { z } from 'zod'

// B-new-2636 — search schema for /$locale/dashboard/mock-interview, kept in a
// route-ignored (`-`) module so the Cucumber layer can import it without the
// router. `jobId`/`src` come from the "Practise an interview" CTAs
// (`buildToolDeepLinkSearch` in -jobs-ai-cta-logic.ts); they MUST be declared
// here so TanStack client navigation carries them into `Route.useSearch()`
// (reading window.location during first render misses them).
// `.catch(undefined)`: a malformed/oversized link degrades to "no linked job"
// instead of throwing the route error boundary, matching the old behaviour.
export const MOCK_INTERVIEW_SRC_VALUES = ['jobs_search_card', 'job_detail', 'browse'] as const

export const mockInterviewSearchSchema = z.object({
  // B-new-1061 — set by the browser extension's "Practise interview" button
  // (the job_applications id it just captured). The API fills the prep form
  // from that row only if it belongs to the user.
  applicationId: z.string().min(1).max(100).optional(),
  jobId: z.string().trim().min(1).max(200).optional().catch(undefined),
  src: z.enum(MOCK_INTERVIEW_SRC_VALUES).optional().catch(undefined),
})
